import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import { Container, Column, Columns, Content } from "bloomer"

import Layout from "../components/layout"
import SEO from "../components/seo"
import BreadcrumbJsonLd from "../components/breadcrumb-jsonld"

const SITE_URL = "https://www.estrelaguia.com.br"

const fmtDate = iso => {
  if (!iso) return ""
  const [y, m, d] = iso.split("T")[0].split("-")
  return `${d}/${m}/${y}`
}

export default function ArtigoSingle({ data }) {
  const { markdownRemark } = data
  const { frontmatter, html, fields, excerpt } = markdownRemark
  const fm = frontmatter
  const faq = (fm.faq || []).filter(f => f && f.q && f.a)

  const articleLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: fm.title,
    description: fm.description || excerpt,
    datePublished: fm.date,
    dateModified: fm.updated || fm.date,
    author: { "@type": "Organization", name: fm.author || "EstrelaGuia" },
    publisher: { "@type": "Organization", name: "EstrelaGuia" },
    image: fm.heroImage ? [fm.heroImage] : undefined,
    mainEntityOfPage: `${SITE_URL}${fields.slug}`,
  }
  const faqLd = faq.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faq.map(f => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }
    : null

  return (
    <Layout>
      <SEO
        title={`${fm.title} | EstrelaGuia`}
        description={fm.description}
        pathname={fields.slug}
        image={fm.heroImage}
        type="article"
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(articleLd)}</script>
        {faqLd && <script type="application/ld+json">{JSON.stringify(faqLd)}</script>}
      </Helmet>
      <BreadcrumbJsonLd
        trail={[
          { name: "Início", path: "/" },
          { name: "Artigos", path: "/artigos/" },
          { name: fm.title, path: fields.slug },
        ]}
      />
      <Container>
        <Columns>
          <Column>
            <article className="artigo">
              <header className="content">
                <h1 className="title is-2">{fm.title}</h1>
                <p className="subtitle is-6 artigo-meta">
                  {fm.category && <span className="artigo-cat">{fm.category}</span>}
                  {fm.date && <span> · {fmtDate(fm.date)}</span>}
                </p>
                {fm.heroImage && (
                  <img className="artigo-hero" src={fm.heroImage} alt={fm.imageAlt || fm.title} />
                )}
              </header>
              <Content dangerouslySetInnerHTML={{ __html: html }} />

              {faq.length > 0 && (
                <Content className="artigo-faq">
                  <h2>Perguntas Frequentes</h2>
                  {faq.map((f, i) => (
                    <div key={i} className="faq-item">
                      <h3>{f.q}</h3>
                      <p>{f.a}</p>
                    </div>
                  ))}
                </Content>
              )}

            </article>
          </Column>
        </Columns>
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      excerpt(pruneLength: 160)
      fields {
        slug
      }
      frontmatter {
        title
        description
        date
        category
        subcategory
        author
        heroImage
        imageAlt
        faq {
          q
          a
        }
      }
    }
  }
`
